import { render, staticRenderFns } from "./AdministrationTask.vue?vue&type=template&id=d67240f6&scoped=true&"
import script from "./AdministrationTask.vue?vue&type=script&lang=js&"
export * from "./AdministrationTask.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationTask.vue?vue&type=style&index=0&id=d67240f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67240f6",
  null
  
)

export default component.exports